import React from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { PDFViewer, Document, Page, Image, Text, View, StyleSheet, pdf, Svg, Defs, LinearGradient, Stop, Rect, Path, Circle, Line } from "@react-pdf/renderer";
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import videovigilancia from '../images/certificado_videovigilancia.png'
import PDFHandler from "../components/pdfs/PDFHandler";
import LOGO from '../images/LogoLAE.png';


export const abrirPDF = async (urlPdf, nombreEmpresa) => {
    // Verificar que nombreEmpresa sea una cadena válida
    if (typeof nombreEmpresa !== 'string' || !nombreEmpresa.trim()) {
        console.error('El nombre de la empresa debe ser una cadena no vacía.');
        return;
      }
  
      // Ruta al archivo PDF base (reemplaza con tu lógica)
      const urlBase = urlPdf;
  
      // Cargar el PDF base
      const response = await fetch(urlBase);
      const existingPdfBytes = await response.arrayBuffer();
  
      // Crear un nuevo documento PDF
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
  
      // Agregar el nombre de la empresa al contenido del PDF
      const { width, height } = pdfDoc.getPage(0).getSize();
      const page = pdfDoc.addPage([width, height]);
  
      // Usar la fuente Helvetica estándar
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  
      // Construir la cadena de texto solo si nombreEmpresa es una cadena válida
      const textoBienvenida = i18next.t('pdfs:common.welcomeTo', { company: nombreEmpresa.trim() });
  
      page.drawText({
        text: textoBienvenida,
        font,
        size: 12,
        color: rgb(0, 0, 0),
        x: 50,
        y: height - 50,
      });
  
      // Crear un enlace temporal
      const pdfBytes = await pdfDoc.save();
      const pdfDataUri = URL.createObjectURL(new Blob([pdfBytes], { type: 'application/pdf' }));
  
      // Abrir el PDF en una nueva ventana o pestaña
      window.open(pdfDataUri, '_blank');
  };

  export const PdfVideoVigilancia = () => {
    const { t } = useTranslation('pdfs');
    const backgroundImageUrl = videovigilancia;

    return (
      <PDFHandler style={{ width: "100%", height: "100vh" }}>
        <Document >
          <Page>
            <View>
              {/* Fondo de la página */}
              <Image src={backgroundImageUrl} style={{ width: "100%", height: "100vh" }} />

              {/* Campo de texto en un punto específico */}
              <Text style={{ position: 'absolute', top: '100px', left: '200px', color: 'red' }}>
                {t('common.textFieldContent')}
              </Text>
            </View>
          </Page>
        </Document>
      </PDFHandler>
    );
  };

const MESES_ES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

const certStyles = StyleSheet.create({
  page: {
    paddingTop: 0,
    paddingBottom: 60,
    paddingHorizontal: 50,
    fontSize: 10,
    fontFamily: 'Helvetica',
    color: '#000',
  },
  logoContainer: {
    alignItems: 'center',
    marginTop: 40,
    marginBottom: 25,
  },
  logo: {
    width: 120,
    objectFit: 'contain',
  },
  titleBarWrapper: {
    height: 22,
    marginBottom: 30,
    position: 'relative',
  },
  titleBarSvg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  titleBarTextWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    color: '#fff',
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
  },
  paragraph: {
    marginBottom: 14,
    lineHeight: 1.6,
    textAlign: 'justify',
  },
  declara: {
    textAlign: 'center',
    color: '#92004D',
    fontFamily: 'Helvetica-Bold',
    textDecoration: 'underline',
    marginTop: 10,
    marginBottom: 20,
    fontSize: 11,
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
  },
  footerWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 42,
  },
  footerSvg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  footerContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 30,
  },
  footerText: {
    color: '#fff',
    fontSize: 8,
  },
  socialIcons: {
    flexDirection: 'row',
  },
  socialIcon: {
    marginLeft: 2,
  },
});

const hexToRgb = (hex) => {
  const h = hex.replace('#', '');
  return [
    parseInt(h.substring(0, 2), 16),
    parseInt(h.substring(2, 4), 16),
    parseInt(h.substring(4, 6), 16),
  ];
};

const rgbToHex = ([r, g, b]) =>
  '#' + [r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('');

const interpolateGradient = (stops, t) => {
  for (let i = 0; i < stops.length - 1; i++) {
    if (t >= stops[i].offset && t <= stops[i + 1].offset) {
      const localT = (t - stops[i].offset) / (stops[i + 1].offset - stops[i].offset);
      const c1 = hexToRgb(stops[i].color);
      const c2 = hexToRgb(stops[i + 1].color);
      return rgbToHex([
        c1[0] + (c2[0] - c1[0]) * localT,
        c1[1] + (c2[1] - c1[1]) * localT,
        c1[2] + (c2[2] - c1[2]) * localT,
      ]);
    }
  }
  return stops[stops.length - 1].color;
};

const GRADIENT_STOPS = [
  { offset: 0, color: '#113d64' },
  { offset: 0.4, color: '#3f3a64' },
  { offset: 0.65, color: '#82355c' },
  { offset: 0.85, color: '#6e5784' },
  { offset: 1, color: '#6b7e9c' },
];

const GRADIENT_SEGMENTS = 120;

const GradientBar = () => (
  <Svg
    viewBox={`0 0 ${GRADIENT_SEGMENTS} 10`}
    preserveAspectRatio="none"
    style={{ width: '100%', height: '100%' }}
  >
    {Array.from({ length: GRADIENT_SEGMENTS }).map((_, i) => (
      <Rect
        key={i}
        x={i - 0.5}
        y={-0.5}
        width={2}
        height={11}
        fill={interpolateGradient(GRADIENT_STOPS, i / (GRADIENT_SEGMENTS - 1))}
      />
    ))}
  </Svg>
);

const IconLinkedin = () => (
  <Svg width="12" height="12" viewBox="0 0 24 24" style={certStyles.socialIcon}>
    <Path
      d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 1 1 8.3 6.5a1.78 1.78 0 0 1-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0 0 13 14.19a.66.66 0 0 0 0 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 0 1 2.7-1.4c1.55 0 3.36.86 3.36 3.66z"
      fill="#fff"
    />
  </Svg>
);

const IconInstagram = () => (
  <Svg width="12" height="12" viewBox="0 0 24 24" style={certStyles.socialIcon}>
    <Path
      fill="#fff"
      d="M 5,2 H 19 A 3,3 0 0 1 22,5 V 19 A 3,3 0 0 1 19,22 H 5 A 3,3 0 0 1 2,19 V 5 A 3,3 0 0 1 5,2 Z M 8,5.5 A 2.5,2.5 0 0 0 5.5,8 V 16 A 2.5,2.5 0 0 0 8,18.5 H 16 A 2.5,2.5 0 0 0 18.5,16 V 8 A 2.5,2.5 0 0 0 16,5.5 H 8 Z M 8.5,7 H 15.5 A 1.5,1.5 0 0 1 17,8.5 V 15.5 A 1.5,1.5 0 0 1 15.5,17 H 8.5 A 1.5,1.5 0 0 1 7,15.5 V 8.5 A 1.5,1.5 0 0 1 8.5,7 Z M 12,9 A 3,3 0 0 0 12,15 A 3,3 0 0 0 12,9 Z M 12,10 A 2,2 0 0 1 12,14 A 2,2 0 0 1 12,10 Z M 16,7.3 A 0.7,0.7 0 0 0 16,8.7 A 0.7,0.7 0 0 0 16,7.3 Z"
    />
  </Svg>
);

const IconFacebook = () => (
  <Svg width="12" height="12" viewBox="0 0 24 24" style={certStyles.socialIcon}>
    <Path
      d="M 5,2 A 3,3 0 0 0 2,5 V 19 A 3,3 0 0 0 5,22 H 19 A 3,3 0 0 0 22,19 V 5 A 3,3 0 0 0 19,2 Z M 10.44,21.88 v-6.99 H7.9 V12 h2.54 V9.8 c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2 v2.46 h-1.26 c-1.24 0-1.63.77-1.63 1.56 V12 h2.77 l-.44 2.89 h-2.33 v6.99 H 10.44 Z"
      fill="#fff"
    />
  </Svg>
);

const CertificadoKaeDocument = ({
  tecnicoNombre,
  titulacion,
  ubicacionFinca,
  categoria,
  lugar,
  dia,
  mes,
  ano,
}) => (
  <Document>
    <Page size="A4" style={certStyles.page}>
      <View style={certStyles.logoContainer}>
        <Image src={LOGO} style={certStyles.logo} />
      </View>
      <View style={certStyles.titleBarWrapper}>
        <View style={certStyles.titleBarSvg}>
          <GradientBar />
        </View>
        <View style={certStyles.titleBarTextWrapper}>
          <Text style={certStyles.titleText}>
            CERTIFICADO TÉCNICO DE FIN DE OBRA - KAE SEÑALÉTICA
          </Text>
        </View>
      </View>

      <Text style={certStyles.paragraph}>
        D./Dª <Text style={certStyles.bold}>{tecnicoNombre || '_______________________________'}</Text>
        , con titulación: <Text style={certStyles.bold}>{titulacion}</Text>,
      </Text>

      <Text style={certStyles.declara}>DECLARA</Text>

      <Text style={certStyles.paragraph}>
        Que bajo mi dirección se han ejecutado los trabajos de señalización de las vías de evacuación en la finca situada en{' '}
        <Text style={certStyles.bold}>{ubicacionFinca || '_______________________________'}</Text>.
      </Text>

      <Text style={certStyles.paragraph}>
        Que dicha instalación se ajusta al proyecto/plan de autoprotección previsto y que las señales han sido colocadas de forma visible, a la altura reglamentaria y garantizando la continuidad del recorrido de evacuación hasta el exterior (punto de reunión).
      </Text>

      <Text style={certStyles.paragraph}>
        Se confirma que todo el material instalado es de Categoría{' '}
        <Text style={certStyles.bold}>{categoria}</Text> y cuenta con el marcado CE correspondiente.
      </Text>

      <Text style={certStyles.paragraph}>
        En <Text style={certStyles.bold}>{lugar || '_______________'}</Text>, a{' '}
        <Text style={certStyles.bold}>{dia || '___'}</Text> de{' '}
        <Text style={certStyles.bold}>{mes || '___________'}</Text> de{' '}
        <Text style={certStyles.bold}>{ano || '______'}</Text>.
      </Text>

      <View style={certStyles.footerWrapper} fixed>
        <View style={certStyles.footerSvg}>
          <GradientBar />
        </View>
        <View style={certStyles.footerContent}>
          <Text style={certStyles.footerText}>
            GRUPO LAE  ·  943 211 151  ·  info@grupolae.net  ·  grupolae.net
          </Text>
          <View style={certStyles.socialIcons}>
            <IconLinkedin />
            <IconInstagram />
            <IconFacebook />
          </View>
        </View>
      </View>
    </Page>
  </Document>
);

export const descargarCertificadoKae = async ({
  tecnicoNombre = '',
  ubicacionFinca = '',
  lugar = '',
  fecha = null,
  nifPropiedad = ''
} = {}) => {
  const d = fecha ? new Date(fecha) : null;
  const valid = d && !isNaN(d.getTime());

  const blob = await pdf(
    <CertificadoKaeDocument
      tecnicoNombre={tecnicoNombre}
      titulacion="Tecnico de Mant. y Señalizacion"
      ubicacionFinca={ubicacionFinca}
      categoria="A"
      lugar={lugar}
      dia={valid ? String(d.getDate()) : ''}
      mes={valid ? MESES_ES[d.getMonth()] : ''}
      ano={valid ? String(d.getFullYear()) : ''}
    />
  ).toBlob();

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Certificado_KAE_${nifPropiedad || 'instalacion'}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};